var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "#FFE240",
    fillOpacity: 0.15,
    stroke: "#FFE240",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 38.6667H44.3334V33.0001H67.0001V38.6667ZM78.3334 27.3334V50.0001L61.3334 67.0001H38.6667C37.1639 67.0001 35.7225 66.4031 34.6598 65.3404C33.5971 64.2776 33.0001 62.8363 33.0001 61.3334V27.3334C33.0001 25.8305 33.5971 24.3892 34.6598 23.3265C35.7225 22.2638 37.1639 21.6667 38.6667 21.6667H72.6667C74.1696 21.6667 75.611 22.2638 76.6737 23.3265C77.7364 24.3892 78.3334 25.8305 78.3334 27.3334ZM72.6667 27.3334H38.6667V61.3334H55.6667V50.0001C55.6667 48.4972 56.2638 47.0558 57.3265 45.9931C58.3892 44.9304 59.8305 44.3334 61.3334 44.3334H72.6667V27.3334ZM27.3334 33.0001C25.8305 33.0001 24.3892 33.5971 23.3265 34.6598C22.2638 35.7225 21.6667 37.1639 21.6667 38.6667V72.6667C21.6667 75.7834 24.2167 78.3334 27.3334 78.3334H61.3334C62.8363 78.3334 64.2776 77.7364 65.3404 76.6737C66.4031 75.611 67.0001 74.1696 67.0001 72.6667H27.3334V33.0001Z",
    fill: "#FFE240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPage);
export default __webpack_public_path__ + "static/media/landing-page.8ed50122eb9d3c15724e4150af8b8957.svg";
export { ForwardRef as ReactComponent };